export default {
  'exception-500.exception.back': '返回首頁',
  'exception-500.description.500': '抱歉，服務器出錯了',
};
